import * as React from "react";

import { useDispatch, useSelector } from "@teamprevent/admin-redux";

import { Base as EmployeeRecords } from "../../employeeRecord";
import { Base as CustomerUsers } from "../../customerUser";
import { Base as OrgStructures } from "../../orgStructure";
import { Base as CustomerDocuments } from "../../customerDocument";
import { Base as QuestionnaireConfig } from "../../../questionnaireConfig";
import { Base as WorkGroups } from "../../workGroup";
import { Base as CustomerSraDepartments, loadCustomerSraDepartments } from "../../customerSraDepartment";
import { Base as CustomerTeams } from "../../customerTeam";
import { ApplicationState } from "../../../applicationState";

import { loadCustomerDetail } from "../actions";

import { All } from "./All";
import { Detail } from "./Detail";
import Edit from "./Edit";
import Create from "./Create";
import { BaseItemExtensions } from "./BaseItemExtensions";
import { BaseRootExtensions } from "./BaseRootExtensions";

import { Fragment, Location } from "redux-little-router";

const noCustomerIdInRoute = (l: Location) => l.params?.customerId === undefined;

export const Base: React.FunctionComponent = () => {
    const dispatch = useDispatch();
    const customerId = useSelector((state: ApplicationState) => state.router.params!.customerId!);

    React.useEffect(() => {
        if (customerId) {
            dispatch(loadCustomerSraDepartments({ customerId }));
            dispatch(loadCustomerDetail({ customerId }));
        }
    }, [customerId, dispatch]);

    return (
        <div>
            <Fragment forRoute="/" withConditions={noCustomerIdInRoute}>
                <div>
                    <All />
                    <Create />
                    <BaseItemExtensions />
                </div>
            </Fragment>
            <Fragment forRoute="/:customerId/employeeRecords">
                <EmployeeRecords />
            </Fragment>
            <Fragment forRoute="/:customerId/customerUsers">
                <CustomerUsers />
            </Fragment>
            <Fragment forRoute="/:customerId/orgStructures">
                <OrgStructures />
            </Fragment>
            <Fragment forRoute="/:customerId/customerDocuments">
                <CustomerDocuments />
            </Fragment>
            <Fragment forRoute="/:customerId/questionnaireConfig">
                <QuestionnaireConfig />
            </Fragment>
            <Fragment forRoute="/:customerId/workGroups">
                <WorkGroups />
            </Fragment>
            <Fragment forRoute="/:customerId/customerSraDepartments">
                <CustomerSraDepartments />
            </Fragment>
            <Fragment forRoute="/:customerId/teams">
                <CustomerTeams />
            </Fragment>
            <Fragment forRoute="/:customerId">
                <div>
                    <Detail />
                    <Edit />
                    <BaseRootExtensions />
                </div>
            </Fragment>
        </div>
    );
};
